export default __webpack_public_path__ + "static/media/contact_banner.41b83613.png";